import 'ui-core/widgets/slideshow/js/slideshow';
(function () {
    var slider = UX.slider;

    slider.set.autoHeight = function () {
        var autoHeight = slider.$slider.closest('.autoheight-slider').data('autoheight');
        if (autoHeight !== undefined) {
            return autoHeight;
        } else {
            return false;
        }
    };

    //Todo add pagination slider on UX3 level
    slider.additionalControls = function () {
        const PAGINATION_SIZE = 7;

        $('.owl-carousel').each(function () {
            if ($(this).parents('.has-numeric-pagination').length) {
                const pagination_size = $(this).find('.owl-dots .owl-dot').length;
                let $owldots = $(this).find('.owl-dots');
                $owldots.wrap('<div class="owl-pagination-wrapper"></div>');
                if (pagination_size > PAGINATION_SIZE) {
                    $owldots.before(
                        "<div class='owl-pagination-prev disabled' tabindex='0' title='Go to previous page of slider pagination'><i class='icon-arrow_l visible'></i></div>"
                    );
                    $owldots.after(
                        "<div class='owl-pagination-next' tabindex='0' title='Go to next page of slider pagination'><i class='icon-arrow_r visible'></i></div>"
                    );
                }

                $('.has-numeric-pagination').delegate('.owl-pagination-next', 'click', function () {
                    const dots = $(this).prev('.owl-dots');
                    const currently_active_item = dots.find('.owl-dot.active').index();

                    if (
                        currently_active_item < pagination_size - 1 &&
                        dots.prev('.owl-pagination-prev').hasClass('disabled')
                    ) {
                        $('.owl-next').trigger('click');
                        dots.prev('.owl-pagination-prev').removeClass('disabled');
                        dots.next('.owl-pagination-next').focus();
                    } else if (currently_active_item === pagination_size - 2) {
                        $('.owl-next').trigger('click');
                        dots.next('.owl-pagination-next').addClass('disabled');
                    } else if (currently_active_item < pagination_size - 1) {
                        $('.owl-next').trigger('click');
                        dots.next('.owl-pagination-next').focus();
                    }
                });

                $('.has-numeric-pagination').delegate('.owl-pagination-prev', 'click', function () {
                    const dots = $(this).next('.owl-dots');
                    const currently_active_item = dots.find('.owl-dot.active').index();

                    if (currently_active_item > 0 && dots.next('.owl-pagination-next').hasClass('disabled')) {
                        $('.owl-prev').trigger('click');
                        dots.next('.owl-pagination-next').removeClass('disabled');
                        dots.prev('.owl-pagination-prev').focus();
                    } else if (currently_active_item === 1) {
                        $('.owl-prev').trigger('click');
                        dots.prev('.owl-pagination-prev').addClass('disabled');
                    } else if (currently_active_item > 0) {
                        $('.owl-prev').trigger('click');
                        dots.prev('.owl-pagination-prev').focus();
                    }
                });
            }
        });
    };
})();
